import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
    createModalPath,
    createModalRouteToolkit,
    useNavigateBackFromModalRoute,
} from 'src/shared/navigation/ModalRouteToolkit';
import { ProviderDetailsModal } from 'src/modules/pathways/components/ProviderDetailsModal';
import { usePathwayQuery } from 'src/modules/pathways/documents/pathway.generated';

const modalPath = createModalPath('provider');

export const PathwayProviderModalPage = () => {
    const { t } = useTranslation();
    const { closeModal } = useNavigateBackFromModalRoute(modalPath);
    const { uuid } = useParams<{ uuid: string }>();
    const { data } = usePathwayQuery({
        variables: {
            uuid,
        },
    });

    if (!data?.pathway) {
        return null;
    }

    const {
        pathway: { memberPathway },
    } = data;

    if (!memberPathway) {
        return null;
    }

    const { pathwayProvider } = memberPathway;

    return (
        <ProviderDetailsModal
            isVisible
            coverImage={pathwayProvider.provider.avatar}
            title={`${pathwayProvider.provider.firstName} ${pathwayProvider.provider.lastName}`}
            subtitle={t('pathways:pathway_specialist')}
            description={pathwayProvider.biography ?? pathwayProvider.provider.digitalBio}
            languages={pathwayProvider.provider.languagePreferences?.join(', ')}
            specialties={pathwayProvider.provider.providerSpecialties?.join(', ')}
            location={pathwayProvider.provider.country}
            onClose={closeModal}
        />
    );
};

export const PathwayProviderModalRouteToolkit = createModalRouteToolkit({
    modalPath,
    component: PathwayProviderModalPage,
});
